import React from 'react';

const ErrorMessage = ({contactEmail, phoneNumber}) => {
	const quote_number = localStorage.getItem('quote_number');

	return (
		<div className="flex w-full">
			<div className="flex flex-col justify-center gap-2.5 text-xl mx-auto text-red-600 shadow-lg rounded-2xl p-6">
				<span>We are unable to complete your estimate at this time.</span>
				<span>Please contact customer service at {phoneNumber} or {contactEmail}.</span>
				<span>
					<b>Your Estimate Number: {quote_number}</b>
				</span>
			</div>
		</div>
	);
};

export default ErrorMessage;
